// extracted by mini-css-extract-plugin
module.exports = {"header":"cashCoupon_header__33TCW","table":"cashCoupon_table__b_MNv"};